<template>
  <footer class="app-footer text-center">
    <p class="h6">Privacy Policy | Terms of Service | Web Accessibility</p>
    <p class="h6">© 2025 Psyncopate, Inc. All rights reserved. | UI Version: {{ guiVersion }}</p>
  </footer>
</template>

<script>
import { pageViews } from "@/utils/util";
// Use require with the correct relative path
const packageJson = require("../../../package.json");

export default {
  name: pageViews.FOOTERVIEW,
  data() {
    return {
      guiVersion: packageJson.guiVersion, // Dynamically use the GUI version
    };
  },
};
</script>

<style scoped>
.app-footer {
  height: 5vh; /* Reduced height */
  background-color: #f8f9fa;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  padding-top: 0.5rem; /* Adjusted padding */
}
.h6 {
  margin: 0;
  font-size: 0.8rem; /* Adjusted font size */
  color: #333; /* Darker text color for better contrast */
}
</style>

